import { VerticalSeparator } from "components/Layout"
import { Translation } from "components/Translations/Translation"

type Props = {
	title: string
	children: any
	showTitleDivider?: boolean
}

export const FormGroup = ({ title, children, showTitleDivider = false }: Props) => {
	return (
		<>
			<h5><Translation i18n={title} /></h5>
			{showTitleDivider &&
				<>
					<hr />
					<VerticalSeparator margin='small' />
				</>
			}
			{children}
		</>
	)
}
